<section class="child">
    <c-tree-explorer config="shortcutConfig"></c-tree-explorer>
</section>